/**
 * `localStorage` under the app's prefix (`REACT_APP_STORAGE_PREFIX`), the web counterpart of the
 * AsyncStorage the app uses. Every access is guarded: a private window or blocked site data throws
 * on read or write, and Notifications V2 must never break the site over that.
 */
export const keyOf = name =>
  `${process.env.REACT_APP_STORAGE_PREFIX}_NOTIFICATIONS_V2_${name}`;

export const read = name => {
  try {
    return window.localStorage.getItem(keyOf(name));
  } catch {
    return null;
  }
};

export const write = (name, value) => {
  try {
    window.localStorage.setItem(keyOf(name), value);
    return true;
  } catch (err) {
    console.warn('[NotificationsV2] cannot write', name, err?.message);
    return false;
  }
};

export const remove = name => {
  try {
    window.localStorage.removeItem(keyOf(name));
  } catch (err) {
    console.warn('[NotificationsV2] cannot remove', name, err?.message);
  }
};

export const readJson = (name, fallback = null) => {
  const raw = read(name);
  if (!raw) {
    return fallback;
  }
  try {
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
};

export const writeJson = (name, value) => write(name, JSON.stringify(value));
